import { t } from "ttag";
import { z } from "zod";

import {
  ADMIN_SESSION_STATUS,
  BLOCK_SUBSCRIPTION_REASON,
  SESSION_CATEGORY,
  SESSION_FREQUENCY,
  SESSION_TITLE_MAX_LENGTH,
} from "./constants";

export const coachSchema = z.object({
  id: z.number({ error: () => t`Coach is required` }),
  name: z.string({ error: () => t`Coach name is required` }),
  email: z.email().nullable(),
});

export const sessionSchema = z.object({
  id: z.number(),
  status: z.enum(ADMIN_SESSION_STATUS),
  title: z
    .string()
    .min(1, { error: () => t`Title is required` })
    .max(SESSION_TITLE_MAX_LENGTH),
  category: z.enum(SESSION_CATEGORY, {
    error: () => t`Category is required`,
  }),
  startAt: z.coerce.date<Date>(),
  duration: z.number({ error: t`Duration is required` }),
  coachId: coachSchema.shape.id,
  published: z.boolean(),
  joinUrl: z.url().nullable(),
  recordingUrl: z.url().nullable(),
  enrolledUsers: z.number().optional(),
  isSubscribable: z.boolean(),
  reasonToBlockSubscription: z.enum(BLOCK_SUBSCRIPTION_REASON).nullable(),
  isSubscribed: z.boolean(),
  coach: coachSchema.nullable(),
});

export const adminSessionSchema = sessionSchema.omit({
  isSubscribable: true,
  reasonToBlockSubscription: true,
  isSubscribed: true,
});

export const subscribedSessionSchema = sessionSchema.omit({
  isSubscribable: true,
  reasonToBlockSubscription: true,
  isSubscribed: true,
});

export const createSessionSchema = sessionSchema
  .pick({
    title: true,
    category: true,
    startAt: true,
    duration: true,
    coachId: true,
    published: true,
  })
  .extend({
    frequency: z.enum(SESSION_FREQUENCY, {
      error: () => t`Frequency is required`,
    }),
    endAt: z.coerce.date<Date>().optional(),
  });
